import axios from "./axiosinstance";

const GroupApi = {
  add: (payload) => axios.post("groups/add", payload),
  list: () => axios.get("groups/list"),
  update: (payload) => axios.post("groups/update", payload),
  delete: (payload) => axios.post("groups/delete", payload),
};

export default GroupApi;